// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"embed-title-author_titleWrapper_1Q3"};